/* src/contexts/profile/profileUtils.js */

/**
 * Sanitizes a tag string: ensures it starts with '#', has valid characters (implicitly),
 * is within length limits, and is not empty after removing '#'.
 * @param {string | null | undefined} tag - The raw tag string.
 * @returns {string | null} The sanitized tag starting with '#' or null if invalid.
 */
export const sanitizeTag = (tag) => {
    const JOURNAL_TAG_PREFIX = '#';
    const JOURNAL_TAG_MAX_LENGTH = 25; // Max length *after* the '#'
  
    if (!tag || typeof tag !== 'string') return null; // Basic validation
  
    let cleanTag = tag.trim();
    if (!cleanTag) return null; // Ignore empty/whitespace tags
  
    // Remove leading '#' characters if present
    while (cleanTag.startsWith(JOURNAL_TAG_PREFIX)) {
      cleanTag = cleanTag.substring(JOURNAL_TAG_PREFIX.length);
    }
  
    // If tag becomes empty after removing '#', it's invalid
    if (!cleanTag) return null;
  
    // Enforce length limit for the tag content itself
    if (cleanTag.length > JOURNAL_TAG_MAX_LENGTH) {
      cleanTag = cleanTag.substring(0, JOURNAL_TAG_MAX_LENGTH);
    }
  
    // Add the prefix back
    return `${JOURNAL_TAG_PREFIX}${cleanTag}`;
  };